import { defaultTheme as theme } from "@deliverr/ui/lib-esm/shared/theme";
import { css } from "@emotion/core";
import styled from "@emotion/styled";

import { TableInput as Input } from "../components/TableInput";
import { Tooltip, TooltipWrapper } from "../components/Tooltip";
import { Grid } from "@deliverr/ui/lib-esm/Grid";
import { Stack } from "@deliverr/ui/lib-esm/Stack";

const placeholderStyles = css`
  color: ${theme.colors.NEUTRAL[300]};
  font-size: ${theme.font.size.F2};
  letter-spacing: normal;
  text-overflow: ellipsis;
  text-transform: none;
  transform: translateY(-0.2rem);
`;

// general styling for "label like" elements in WP forms
// MOST of the time, this is for actual <label> elements, but there are a few cases
// where we want other elements to look like labels without affecting a11y
export const labelStyles = css`
  color: ${theme.colors.NEUTRAL[300]};
  font-family: ${theme.font.family.STANDARD};
  font-size: ${theme.font.size.F2};
  margin-bottom: ${theme.spacing.S1};
  text-align: left;
`;

export const OpsInputForm = styled.form`
  align-items: left;
  flex-direction: column;
  padding: ${theme.spacing.S5};
  padding-top: ${theme.spacing.S3};
`;

export const OpsInputFormInput = styled(Input)`
  width: 100%;

  &::placeholder {
    ${placeholderStyles};
  }
`;

export const OpsInputFormInputUpper = styled(OpsInputFormInput)`
  text-transform: uppercase;
`;

export const OpsInputFormInputLower = styled(OpsInputFormInput)`
  text-transform: lowercase;
`;

export const OpsInputFormLabel = styled.label`
  ${labelStyles};
  margin-bottom: ${theme.spacing.S1};
  margin-right: ${theme.spacing.S2};
`;

export const OpsInputFormImageGrid = styled(Grid)`
  margin-bottom: ${theme.spacing.S4};
  width: 100%;
`;

export const OpsInputFormInputSection = styled.table`
  margin-bottom: ${theme.spacing.S5};
`;

// container for text area and its label
export const OpsInputFormOtherDetails = styled.div`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
`;

export const OpsInputFormRadioButton = styled.input`
  margin-right: ${theme.spacing.S1};
`;

export const OpsInputFormRadioButtonGroup = styled.div`
  display: flex;
  align-items: center;
`;

const RadioGroup = Stack.withComponent("fieldset");
export const OpsInputFormRadioStack = styled(RadioGroup)`
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${theme.spacing.S4};
  margin-top: ${theme.spacing.S4};
`;

export const OpsInputFormRadioTitle = styled.p`
  ${labelStyles};
  margin-bottom: ${theme.spacing.S1};
`;

export const OpsInputFormSubTitle = styled.p`
  color: ${theme.colors.NEUTRAL[300]};
  font-family: ${theme.font.family.STANDARD};
  margin-bottom: ${theme.spacing.S6};
`;

export const OpsInputFormTooltip = styled(Tooltip)`
  margin-top: ${theme.spacing.S1};
`;

export const OpsInputFormTooltipWrapper = styled(TooltipWrapper)`
  margin-bottom: ${theme.spacing.S3};
  width: 100%;
`;

export const OpsInputFormTextArea = styled.textarea`
  border: solid 1px ${theme.colors.NEUTRAL[300]};
  min-height: 120px;
  width: 100%;
  padding: ${theme.spacing.S2};

  &::placeholder {
    ${placeholderStyles};
  }
`;

export const OpsInputFormSelect = styled.select`
  width: 100%;

  &::placeholder {
    ${placeholderStyles};
  }
`;

export const StyledLabel = styled.label`
  color: ${theme.colors.NEUTRAL[300]};
  font-family: ${theme.font.family.STANDARD};
  font-size: ${theme.font.size.F2};
  margin-bottom: 0.25rem;
  text-align: left;
`;

export const StyledCell = styled.td`
  padding-left: 10pt;
  vertical-align: top;
`;
